import { Button } from '@/components/ui/button';

import { useCurrentUser } from '../hooks/useCurrentUser';
import { useOpenLinkedAccounts } from '../hooks/useOpenLinkedAccounts';
import {
  blockedAccountSentence,
  linkActionLabel,
  type MissingHost,
} from '../personalAccounts';

/**
 * Why a run was blocked for want of its person's own forge account (spec 160
 * US3), for whoever reads it: "your own …" and a way to link for that person,
 * "Jane Doe's own …" and nothing to do for anyone else — only they can link.
 */
export function NeedsAccountReason({
  hosts,
  personId,
  personName,
  className = 'text-foreground text-xs',
}: {
  hosts: readonly MissingHost[];
  personId: string | null;
  personName: string | null;
  className?: string;
}) {
  const me = useCurrentUser();
  const openLinkedAccounts = useOpenLinkedAccounts();
  const mine = personId !== null && me.data?.id === personId;
  return (
    <span className="flex flex-col items-start gap-1">
      <span className={className}>
        {blockedAccountSentence(
          hosts,
          mine ? null : (personName ?? 'its person'),
        )}
      </span>
      {mine ? (
        <Button
          variant="link"
          size="sm"
          className="h-auto px-0 text-xs"
          onClick={(event) => {
            // Inside an activatable card or row: linking must not also open it.
            event.stopPropagation();
            openLinkedAccounts();
          }}
        >
          {linkActionLabel(hosts)}
        </Button>
      ) : null}
    </span>
  );
}
